import React from 'react';
import classNames from 'classnames';
import { Button, TextInput, Select, Dialog } from '@sravni/react-design-system';
import styles from './common.module.scss';

export { Button, TextInput, Select, Dialog };

export const Paper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...others }) => {
    return (
        <div className={classNames(styles.paper, className)} {...others}>
            {children}
        </div>
    );
};

export const Label: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...others }) => {
    return (
        <div className={classNames(styles.darkLabel, className)} {...others}>
            {children}
        </div>
    );
};

export const LinkButton: React.FC<
    React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({ className, children, ...others }) => {
    return (
        <a className={classNames(styles.linkButton, className)} {...others}>
            {children}
        </a>
    );
};
